import { render, staticRenderFns } from "./ShareEvaluationList.vue?vue&type=template&id=48826e4e&"
import script from "./ShareEvaluationList.vue?vue&type=script&lang=js&"
export * from "./ShareEvaluationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports